import { StyleSheet } from '@react-pdf/renderer';
export const styles = StyleSheet.create({
  colorBlack: {
    color: 'black'
  },
  paddingBottomPointTwoCm: {
    paddingBottom: '.2cm'
  },
  paddingBottomPointOneCm: {
    paddingBottom: '.1cm'
  },
  paddingBottomPointThreeCm: {
    paddingBottom: '.3cm'
  },
  paddingBottomTenCm: {
    paddingBottom: '10cm'
  },
  paddingBottomTwoCm: {
    paddingBottom: '2cm'
  },
  paddingPointOneCm: {
    padding: '.1cm'
  },
  paddingPointTwoCm: {
    padding: '.2cm'
  },
  paddingRightPointOneCm: {
    paddingRight: '.1cm'
  },
  paddingTopPointOneCm: {
    paddingTop: '.1cm'
  },
  fontFamilyItalic: {
    fontFamily: 'Times-Italic'
  },
  paddingLeftPointTwoCm: {
    paddingLeft: '.2cm'
  },
  paddingLeftPointFourCm: {
    paddingLeft: '.4cm'
  },
  paddingLeftPointFiveCm: {
    paddingLeft: '.5cm'
  },
  carePlanProblemHeader: {
    fontSize: '12pt',
    fontFamily: 'Helvetica-Bold',
    paddingTop: '.1cm',
    paddingBottom: '.1cm',
    textDecoration: 'underline'
  },
  page: {
    paddingLeft: '1cm',
    paddingRight: '1cm',
    paddingTop: '1.6cm',
    paddingBottom: '3cm'
  },
  pageSafari: {
    paddingLeft: '1cm',
    paddingRight: '1cm',
    paddingTop: '2.35cm',
    paddingBottom: '2.35cm'
  },
  fontSizeTwelvePt: {
    fontSize: '12pt'
  },
  fontSizeElevenPt: {
    fontSize: '11pt'
  },
  fontSizeTenPt: {
    fontSize: '10pt'
  },
  fontSizeNinePt: {
    fontSize: '9pt'
  },
  fontSizeEightPt: {
    fontSize: '8pt'
  },
  fontSizeSixPt: {
    fontSize: '6pt'
  },
  marginYPointTwoCm: {
    margin: '.2cm'
  },
  marginLeftPointOneCm: {
    marginLeft: '.1cm'
  },
  marginLeftPointTwoCm: {
    marginLeft: '.2cm'
  },
  marginLeftPointFiveCm: {
    marginLeft: '.5cm'
  },
  marginLeftTwoCm: {
    marginLeft: '2cm'
  },
  marginRightOneCm: {
    marginRight: '1cm'
  },
  fontWeightBold: {
    fontFamily: 'Helvetica-Bold'
  },
  marginBottomPointFiveCm: {
    paddingBottom: '.5cm'
  },
  mYPointFiveCm: {
    marginTop: '.5cm',
    marginBottom: '.5cm'
  },
  pYPointOneCm: {
    paddingTop: '.1cm',
    paddingBottom: '.1cm'
  },
  borderBottomBlack: {
    borderBottom: '1 solid black'
  },
  pdfIframe: {
    height: '100vh'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  rowTask: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '.1cm'
  },
  justifyContentCenter: {
    justifyContent: 'center'
  },
  justifyContentBetween: {
    justifyContent: 'space-between'
  },
  justifyContentAround: {
    justifyContent: 'space-around'
  },
  width100: {
    width: '100%'
  },
  width85: {
    width: '85%'
  },
  width50: {
    width: '50%'
  },
  width40: {
    width: '40%'
  },
  width30: {
    width: '30%'
  },
  width75: {
    width: '75%'
  },
  width33: {
    width: '33%'
  },
  width66: {
    width: '66%'
  },
  width25: {
    width: '25%'
  },
  width20: {
    width: '20%'
  },
  width16: {
    width: '16%'
  },
  width15: {
    width: '15%'
  },
  width12point5: {
    width: '12.5%'
  },
  width12: {
    width: '12%'
  },
  width13: {
    width: '13%'
  },
  width10: {
    width: '10%'
  },
  width8: {
    width: '8%'
  },
  width6: {
    width: '6%'
  },
  width5: {
    width: '5%'
  },
  width250: {
    width: '390px'
  },
  width190: {
    width: '240px'
  },
  textAlignCenter: {
    textAlign: 'center'
  },
  printerHeaderText: {
    fontFamily: 'Times-Roman',
    textDecoration: 'underline',
    fontWeight: 700,
    fontSize: '14pt',
    paddingBottom: '0.1cm'
  },
  printerSubHeader: {
    fontSize: '8pt'
  },
  FacesheetHeaderField: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '8pt'
  },
  FacesheetText: {
    fontFamily: 'Helvetica',
    fontSize: '8pt'
  },
  CPFTableDetailsText: {
    fontFamily: 'Helvetica',
    fontSize: '9pt'
  },
  CPFTableRowHeaderText: {
    fontFamily: 'Helvetica',
    fontSize: '12pt'
  },
  detailsUnderNameHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: '.2cm',
    paddingBottom: '.2cm',
    borderBottom: '1 solid black'
  },
  profilePicture: {
    padding: '.2cm',
    height: '4cm',
    width: '2.5cm'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  pageHeader: {
    position: 'absolute',
    width: '100%',
    top: '1cm',
    left: '1cm',
    right: '1cm'
  },
  safariPageHeader: {
    position: 'absolute',
    width: '100%',
    top: '2cm',
    left: '1cm',
    right: '1cm'
  },
  pageFooter: {
    position: 'absolute',
    width: '100%',
    bottom: '2.25cm',
    left: '1cm',
    right: '1cm'
  },
  coverSheetSquare: {
    border: '1 solid black',
    position: 'relative',
    top: '15%',
    width: '85%',
    margin: '0 auto'
  },
  coverSheetColumn: {
    width: '50%',
    padding: '.2cm .2cm 0 .2cm'
  },
  textDecorationLineThrough: {
    textDecoration: 'line-through'
  },
  textDecorationUnderline: {
    textDecoration: 'underline'
  },
  paddingBottomPointFiveCm: {
    marginBottom: '.5cm'
  },
  backgroundColorNone: {
    backgroundColor: 'none'
  },
  backgroundColorDarkGray: {
    backgroundColor: '#adadad'
  },
  backgroundColorGray: {
    backgroundColor: '#d9d9d9'
  },
  marginTopPointFiveCm: {
    marginTop: '.5cm'
  },
  marginTopPointTwoCm: {
    marginTop: '.2cm'
  },
  medsTableRowHeaderText: {
    fontFamily: 'Helvetica-Bold',
    fontSize: '9pt'
  },
  medsTableMainDetailsText: {
    fontSize: '8pt'
  },
  primaryPayerTextStyles: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginTop: '.2cm',
    marginLeft: '.2cm'
  },
  firstCertCardStyles: {
    height: '70vh'
  },
  certCardStyles: {
    height: '80vh'
  }
});